import imagesPillarPages from '../imagesPillarPages';
import imagesLandingPages from '../imagesLandingPages';

export default {
  headingText: {
    title: `Build MVP to launch your product fast. <br /> Hit the market in the most effective way!`,
    description: `Verify if there is a room for your product on the market through MVP development. It’s the fastest and most efficient way to test your product or service with the real audience. Build your minimum viable product with core features first, and turn it into a full product later. You will get our full support on the whole way to success.`,
    img: imagesPillarPages.rocketSVG
  },
  softwaresText: {
    title: 'Why does your startup need minimum viable product?',
    subtitle:
      'There are numerous benefits of MVP development for businesses. In essence, this process verifies your idea and explores product potential on the market. What other profits can you gain with minimum viable development?',
    description:
      'All the great software we create in Python is in accordance with a standardized workflow and Scrum methodology.',
    businessList: [
      {
        icon: imagesPillarPages.cheapSVG,
        title: 'Cost-efficient way of building a product',
        description: `When building and releasing an MVP, you avoid investing large sums of money in creating a fully-functional product. It also helps to avoid spending money developing extra functionalities that may ultimately be unnecessary.`
      },
      {
        icon: imagesPillarPages.buildingproductsSVG,
        title: 'Idea validation',
        description: `We live in an era where all your assumptions may be deeply verified. An MVP enables you to test your business hypothesis and save time and money. Don’t allocate resources to a product based on incomplete data.`
      },
      {
        icon: imagesPillarPages.performanceSVG,
        title: 'Faster product development',
        description: `Developing an MVP maximizes the time and effort your business put into your product or service. Bringing an MVP to market takes considerably less time than launching a fully functional product.`
      },
      {
        icon: imagesPillarPages.ondemandSVG,
        title: 'Viability test',
        description: `Your product can be highly efficient and use the least amount of features to solve your end-user problem. After you make sure that your MVP provides value for your customers, you can easily develop a full product.`
      }
    ]
  },
  sectionBoxes: {
    title: `MVP is an early version of your end-product, build it the right
      way from the start`,
    subtitle: `There is no better way to test your idea than to develop MVP.
      Choose a development company to make this process smooth and
      agile. Strong history in building MVPs across various industries
      makes us refine this process over years. Now we can assure you
      that your minimum viable product will be:`,
    singleBox: [
      {
        src: imagesPillarPages.backendSVG,
        title: 'Build with state-of-the-art technology',
        subtitle:
          'Your product will be built using the most modern techniques and technology. This is what we do daily, and we really enjoy it!'
      },
      {
        src: imagesLandingPages.ourroleSVG,
        title: 'Engaging to the users',
        subtitle:
          'Your users will be delighted using interactive apps, either web or mobile. Make a good first impression even if it is the only early version of your product.'
      },
      {
        src: imagesLandingPages.icon1SVG,
        title: 'Secure',
        subtitle:
          'We build crypto products for Fintech clients where the security of application is always a top priority. Your MVP will be built the same way.'
      },
      {
        src: imagesLandingPages.resultsSVG,
        title: 'Future-proof',
        subtitle: `MVP development is all about creating feasible plans for future improvements. Whether you will be adding new features or pivoting, your MVP will be already prepared for your next move.`
      }
    ]
  },
  mvpBox: {
    title: 'Why work with a technology partner?',
    subtitle:
      'Building a high-quality minimum viable product that will charm your customers requires different sets of skills:',
    list: `<ul>
            <li>Front-end and back-end professionals to build the functionality and features</li>
            <li>UI/UX experts to provide an outstanding user experience</li>
            <li>A project manager to control development process</li>
            <li>Know-how to build cutting-edge software products</li>
          </ul>`,
    additionalInfo:
      'A reliable development agency can provide you with experienced professionals that you need for your product.'
  },
  dedicData: {
    title:
      'Minimum viable product for startups - what challenges you may face?',
    list: [
      `Many startups fail because of the lack of product-market fit. However, with a reliable MVP development company and in-depth research, you can reduce the chances of failure as much as possible.`,
      `As a startup planning to launch your first product, you probably don’t have the set of technical skills to build MVP properly. Our experienced development team will guide you through the whole development process.`,
      `Hiring in-house developers might be both expensive and risky. Have in mind that you launch your MVP to test your idea. It means that you would need to get involved in contracts only to take a test.`
    ]
  },
  telecomSectionData: {
    title: 'Work with top MVP development company on your project',
    description: [
      'Choosing the right technology partner for your business is not easy.',
      `At Ulam Labs, we assist you in each step of your MVP development, from the idea, through planning, across the development stage, till the release.`,
      `We provide a comprehensive range of services for end-to-end product development, including design, development, implementation and support. We build scalable and robust software solutions for enterprises and startups.`
    ],
    list: [
      'since 2012 on the market',
      '20+ successful projects',
      'Startups and SME oriented',
      'All range of industries: Fintech, Telco, E-commerce, and more...'
    ],
    btnText: "Let's work together"
  },
  steps: {
    stepOne: {
      title: 'Idea validation with technical analysis',
      description:
        'The initial and obligatory step is validating the idea. With this phase you will get a clear answer if the idea can become a real product in the future. We also advise on the best tech stack for the product. Tech stack is all of the digital tools and technologies we’ll utilize to develop MVP.'
    },
    stepTwo: {
      title: 'Discovery workshop',
      description: `Discovery workshop provides a basis for you and software development company to work towards envisioning a product and the business behind it. This is a stage where all crucial decisions will be made like technology stack or essential features. As a result, you can expect low fidelity wireframes and well defined user stories together with a timeline for your entire product. After the workshop both parties understand the size of the project, as well as the client’s objectives and expectations.`,
      stepNumber: 2
    },
    stepThree: {
      title: 'Development and design process',
      description: `We use Scrum to manage all MVP projects. It’s the best framework in agile methodologies for teams that need to deliver results fast. 
      We work in two-week sprints, incorporating planning, development, testing, reviews. Each sprint starts with planning and finishes with a demo to present the current progress of MVP development. Moreover, through the whole development phase you have permanent access to the live version of the application to help you win shareholders’ and investors' interests.`,
      stepNumber: 3
    },
    stepFour: {
      title: "Client's UAT",
      description: `At this step, your application is tested by our development team and is ready to hit the market. It’s the last time to check if your MVP meets all business requirements and there was no miscommunication. After your final sign off, we can move to the most exciting phase - the launch.`,
      stepNumber: 4
    },
    stepFive: {
      title: 'MVP launch',
      description: `Minimum viable product is ready for the market and our team releases it. Once your product is deployed, you can start using it and gather feedback instantly. Now you can start thinking about these extra features that you scoped out of the MVP and plan your product in a multi year perspective.`,
      stepNumber: 5
    },
    stepSix: {
      title: 'Manage your MVP',
      description: `When your MVP is delivered, all you need to do is to focus on your business. We take care of the operational part to keep things running smoothly. AWS or Google? We manage the infrastructure of tens of apps for our clients on many different clouds. We will oversee security, server updates, performance monitoring, nightly backups, the regular maintenance of features, bug fixes and changes.`,
      stepNumber: 6
    }
  }
};
